<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${purchasesPayment.code}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="purchasesPayment" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "purchasesPayment-view-logs",

  components: { LogListTable },

  props: ["purchasesPayment"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
